import React, { useEffect } from 'react';

const PerformanceOptimizations = () => {
  useEffect(() => {
    // Preload critical resources
    const preloadResources = () => {
      // Preload hero image
      const heroImage = new Image();
      heroImage.src = "https://images.unsplash.com/photo-1724906019868-93ad2c79414f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjB0ZWNobm9sb2d5JTIwY29sbGFib3JhdGlvbnxlbnwwfHx8fDE3NTg0MTA4NTJ8MA&ixlib=rb-4.1.0&q=85";
      
      // Preload logo
      const logo = new Image();
      logo.src = "https://customer-assets.emergentagent.com/job_loveyuh-bizhelp/artifacts/agf3ac47_FullColor_BlackBackground1280x1024_72dpi.png";
    };

    // Optimize font loading
    const optimizeFonts = () => {
      // Add font-display: swap to improve loading performance
      const style = document.createElement('style');
      style.textContent = `
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;900&display=swap');
      `;
      document.head.appendChild(style);
    };

    // Add performance hints
    const addPerformanceHints = () => {
      // DNS prefetch for external domains
      const dnsPrefetch = [
        'https://fonts.googleapis.com',
        'https://fonts.gstatic.com',
        'https://images.unsplash.com',
        'https://customer-assets.emergentagent.com'
      ];

      dnsPrefetch.forEach(domain => {
        const link = document.createElement('link');
        link.rel = 'dns-prefetch';
        link.href = domain;
        document.head.appendChild(link);
      });

      // Preconnect to critical origins
      const preconnectDomains = [
        'https://fonts.googleapis.com',
        'https://fonts.gstatic.com'
      ];

      preconnectDomains.forEach(domain => {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = domain;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      });
    };

    // Lazy load non-critical resources after initial load
    const lazyLoadResources = () => {
      setTimeout(() => {
        preloadResources();
      }, 100);
    };

    // Initialize optimizations
    addPerformanceHints();
    optimizeFonts();
    lazyLoadResources();

    // Service Worker registration for caching
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('SW registered: ', registration);
          })
          .catch((registrationError) => {
            console.log('SW registration failed: ', registrationError);
          });
      });
    }
  }, []);

  return null; // This component doesn't render anything
};

export default PerformanceOptimizations;